import { ArrowRight, UserPlus } from "lucide-react";
import { useState, type FormEvent } from "react";

import { BrandMark } from "../components/BrandMark";
import { PasswordField } from "../components/PasswordField";

type AcceptInvitePageProps = {
  token: string;
  onAccept: (input: { token: string; name: string; password: string }) => Promise<unknown>;
  loading: boolean;
  error: string | null;
};

export function AcceptInvitePage({ token, onAccept, loading, error }: AcceptInvitePageProps) {
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  async function submit(event: FormEvent) {
    event.preventDefault();
    await onAccept({ token, name, password });
  }
  return (
    <main className="invite-page">
      <BrandMark />
      <section className="invite-card">
        <span className="invite-card__icon"><UserPlus /></span>
        <p className="eyebrow">Invito ricevuto</p>
        <h1>Entra nella squadra</h1>
        <p>Completa il tuo profilo. Vedrai subito le strutture e i lavori che ti sono stati assegnati.</p>
        <form onSubmit={submit}>
          <label><span>Nome e cognome</span><input value={name} onChange={(event) => setName(event.target.value)} minLength={2} required autoComplete="name" /></label>
          <PasswordField label="Scegli una password" value={password} onChange={(event) => setPassword(event.target.value)} minLength={10} required autoComplete="new-password" />
          {error && <p className="form-error" role="alert">{error}</p>}
          <button className="button button--primary button--wide" disabled={loading}>{loading ? "Creazione profilo..." : "Entra nella squadra"}<ArrowRight size={18} /></button>
        </form>
      </section>
    </main>
  );
}
